module.exports = __webpack_public_path__ + "img/share@2x.7b3f82fd.png";